const laxuraPlatinum = {
    title: "Luxara Platinum Mattress",
    content: {
        "Queen Price": "RRP: $2,490",
        "Mattress Type": "Luxury Hybrid Innerspring",
        "Number of Layers": "11",
        "Quilted Pillow Top": "10cm",
        "Made In Australia": "Yes",
        "GECA Certification": "Yes",
        "Sensitive Choice® Approved Asthma Friendly Foams": "Yes",
        "Australian Made Dunlop Foam Layers": "Yes"
    }
}

const laxuraClassic = {
    title: "Luxara Classic Mattress",
    content: {
        "Queen Price": "RRP: $1,890",
        "Mattress Type": "Premium Hybrid Innerspring",
        "Number of Layers": "9",
        "Quilted Pillow Top": "7cm",
        "Made In Australia": "Yes",
        "GECA Certification": "Yes",
        "Sensitive Choice® Approved Asthma Friendly Foams": "Yes",
        "Australian Made Dunlop Foam Layers": "Yes"
    }
}

const sealyCrown = {
    title: "Sealy Posturepedic Crown Jewel Mattress",
    content: {
        "Queen Price": "RRP: Starting from $9,399",
        "Mattress Type": "Luxury Hybrid Innerspring",
        "Number of Layers": "9",
        "Quilted Pillow Top": "Only on Select Models",
        "Made In Australia": "Yes",
        "GECA Certification": "No",
        "Sensitive Choice® Approved Asthma Friendly Foams": "No",
        "Australian Made Dunlop Foam Layers": "No"
    }
}

const sealyExquisite = {
    title: "Sealy Posturepedic Exquisite Mattress",
    content: {
        "Queen Price": "RRP: Starting from $6,199",
        "Mattress Type": "Premium Hybrid Innerspring",
        "Number of Layers": "9",
        "Quilted Pillow Top": "Only on Select Models",
        "Made In Australia": "Yes",
        "GECA Certification": "No",
        "Sensitive Choice® Approved Asthma Friendly Foams": "No",
        "Australian Made Dunlop Foam Layers": "No"
    }
}

const sleepingDuck = {
    title: "Sleeping Duck SD Mach II Mattress",
    content: {
        "Queen Price": "RRP: $1,649",
        "Mattress Type": "Hybrid Innerspring",
        "Number of Layers": "4",
        "Quilted Pillow Top": "No",
        "Made In Australia": "<img src='//luxara.com.au/cdn/shop/t/22/assets/cross.png?v=127061121075728922481758637412' class='cross' style='height: 24px'/> <br> (Made in China)",
        "GECA Certification": "Yes",
        "Sensitive Choice® Approved Asthma Friendly Foams": "No",
        "Australian Made Dunlop Foam Layers": "No"
    }
}

const koalaSoul = {
    title: "Koala Soul Mate Mattress",
    content: {
        "Queen Price": "RRP: $2,390",
        "Mattress Type": "Foam",
        "Number of Layers": "2",
        "Quilted Pillow Top": "No",
        "Made In Australia": "<img src='//luxara.com.au/cdn/shop/t/22/assets/cross.png?v=127061121075728922481758637412' class='cross' style='height: 24px'/> <br> (Made in China)",
        "GECA Certification": "No",
        "Sensitive Choice® Approved Asthma Friendly Foams": "No",
        "Australian Made Dunlop Foam Layers": "No"
    }
}

const koalaCalm = {
    title: "Koala Calm As Mattress",
    content: {
        "Queen Price": "RRP: $1,650",
        "Mattress Type": "Foam",
        "Number of Layers": "2",
        "Quilted Pillow Top": "No",
        "Made In Australia": "<img src='//luxara.com.au/cdn/shop/t/22/assets/cross.png?v=127061121075728922481758637412' class='cross' style='height: 24px'/> <br> (Made in China)",
        "GECA Certification": "Yes",
        "Sensitive Choice® Approved Asthma Friendly Foams": "No",
        "Australian Made Dunlop Foam Layers": "No"
    }
}

const mattresses = {
    laxuraPlatinum,
    laxuraClassic,
    sealyCrown,
    sealyExquisite,
    sleepingDuck,
    koalaSoul,
    koalaCalm
}